export const pathname = "/about-mynews";

export const page = {
  route(this: void, query: QueryParameters<{ char?: string }>) {
    return {
      pathname,
      query: { ...query, pageType: "mynews" },
    };
  },
};
